import React from 'react';
import Nav from './components/sidenav/sideNav';
import Main from './mainwrapper'
import "./App.css";

function App() {
  return (
    <>
      <Main />
      <Nav />
    </>  
  );
}

export default App;
